import { t } from '@gem/modules/i18n';
import { media } from '@gem/modules/permissions';

import Tasks from 'APP/Tasks';
import deviceInfo from 'APP/packages/deviceInfo';

export default async (deviceId) => {
  const { hasCamera } = await deviceInfo.getMediaDevices();

  if (!hasCamera) {
    Tasks.app.showAlert(t('calls_no_camera_connected'));

    return false;
  }

  const hasVideoPermission = await media.getVideoPermission(deviceId);

  if (!hasVideoPermission) {
    Tasks.app.showAlert(t('calls_no_camera_permissions_web'));
    return false;
  }

  return true;
};
